module.exports = __webpack_public_path__ + "static/media/ralko-r-en.debf7535.png";